export enum TagTypeEnum {
    free = 1,
    report,
    estimation
}
